package kotlinReactComponents

import constants.CompanyConstants.Companion.dropDownMenuEntriesProdukte
import constants.RuleSetClass
import kotlinx.html.js.onMouseDownFunction
import kotlinx.html.js.onMouseOutFunction
import kotlinx.html.js.onMouseOverFunction
import org.w3c.dom.HTMLElement
import react.Props
import react.dom.attrs
import react.fc
import react.useState
import styled.css
import styled.styledDiv
import styled.styledSpan

external interface DropdownMenuProps: Props {
    var title: String
    var entries: Array<String>
    var clickedEntryDropDownProp: String
    var onClickedEntryDropDownPropChange : (String) -> Unit
    var titleStyleClass: RuleSetClass
    var entryBlockStyleClass: RuleSetClass
    var eachEntryStyleClass: RuleSetClass
}

//fun RBuilder.dropDownMenu(title: String, entries: Array<String>, clickedEntry: KMutableProperty0<String>, titleStyle: RuleSet, entryBlockStyle: RuleSet, eachEntryStyle: RuleSet) {
val dropDownMenu = fc<DropdownMenuProps>("DropdownMenu") { props ->

    var mouseIsOver: String by useState("")
    var dropDownVisible: Boolean by useState(false)

    styledDiv {
        css {
            +DropdownMenuStyles.dropdown
            +dropDownMenuEntriesProdukte.titleStyle.style
            +props.titleStyleClass.style
        }
        attrs {
            onMouseOverFunction = { event ->
                dropDownVisible = true
                mouseIsOver = (event.target as HTMLElement).innerText
            }
            onMouseOutFunction = {
                dropDownVisible = false
                mouseIsOver = ""
            }
        }
        styledSpan {
            styledDiv {
                css {

                    if (mouseIsOver == props.title) {
                        +DropdownMenuStyles.boldText
                    } else {
                        +DropdownMenuStyles.normalText
                    }
                }
                attrs.text(props.title)
                attrs {
                    onMouseDownFunction = { event ->
                    dropDownVisible = true
                    props.onClickedEntryDropDownPropChange((event.target as HTMLElement).innerText)
                    }
                }
            }

            styledDiv {
                css {
                    +props.entryBlockStyleClass.style
                    +DropdownMenuStyles.dropdownContent
                    if (dropDownVisible) {
                        +DropdownMenuStyles.displayBlock
                    } else {
                        +DropdownMenuStyles.displayNone
                    }
                }

                attrs {
                    onMouseDownFunction = { event ->
                    dropDownVisible = false
//                    props.clickedEntryDropDownProp = (event.target as HTMLElement).innerText
                    props.onClickedEntryDropDownPropChange((event.target as HTMLElement).innerText)
                    }
                }

                for (index in 0..props.entries.lastIndex) {
                    styledDiv {
                        css {
                            +props.eachEntryStyleClass.style
                            if (mouseIsOver == props.entries[index]) {
                                +DropdownMenuStyles.boldText
                            } else {
                                +DropdownMenuStyles.normalText
                            }
                            if (index == props.entries.lastIndex) {
                                +DropdownMenuStyles.noBorder
                            } else {
                                +DropdownMenuStyles.contentElementBorder
                            }
                        }

                        attrs.text(props.entries[index])
                        attrs {
                            onMouseOverFunction = { event ->
                            dropDownVisible = false
                            mouseIsOver = (event.target as HTMLElement).innerText
                            }
                            onMouseOutFunction = {
                            mouseIsOver = ""
                            }
                        }
                    }
                }
            }
        }
    }
}


